import { useDispatch } from 'react-redux'
import { ContactAddressType } from '../common/ContactAddress.type'
import { editContactAddress } from '../slices/contactAddressSlice'
import useNavigatePrevPage from './useNavigatePrevPage'

const useEditContact = () => {
  const dispatch = useDispatch()

  const editContact = (contactAddress: ContactAddressType) => {
    dispatch(editContactAddress(contactAddress))
  }

  const { navigatePrevPage } = useNavigatePrevPage()

  return { editContact, navigatePrevPage }
}

export default useEditContact
